import { render, staticRenderFns } from "./PromptRemove.vue?vue&type=template&id=955a4790&"
import script from "./PromptRemove.vue?vue&type=script&lang=js&"
export * from "./PromptRemove.vue?vue&type=script&lang=js&"
import style0 from "./PromptRemove.vue?vue&type=style&index=0&id=955a4790&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports